"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestRemoveTab = exports.activateTab = exports.MainTabsView = void 0;
__exportStar(require("./types"), exports);
var main_tabs_view_1 = require("./main-tabs-view");
Object.defineProperty(exports, "MainTabsView", { enumerable: true, get: function () { return main_tabs_view_1.MainTabsView; } });
var actions_1 = require("./actions");
Object.defineProperty(exports, "activateTab", { enumerable: true, get: function () { return actions_1.activateTab; } });
Object.defineProperty(exports, "requestRemoveTab", { enumerable: true, get: function () { return actions_1.requestRemoveTab; } });
//# sourceMappingURL=index.js.map